$('.toggle-team').click(function (e) {
	e.preventDefault();
	if ($(this).siblings('.desc').hasClass('hide')) {
		$(this).siblings('.desc').removeClass('hide');
		$(this).removeClass('hide');
		$(this).html('<i class="fa-solid fa-circle-chevron-down"></i>Read Less');
	} else if (!$(this).siblings('.desc').hasClass('hide')) {
		$(this).siblings('.desc').addClass('hide');
		$(this).addClass('hide');
		$(this).html('<i class="fa-solid fa-circle-chevron-down"></i>Read More');
	}
});
